import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';




import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';


const GitaDharaClass3 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara3/5.webp`;

   
    const photos = [
      
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               Bhagavad Gita
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Class: 3    Date: 5, 9, 18 December 2025  <br />
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “The Bhagavad Gita teaches us how to live with clarity, courage, and compassion by doing our duty with the right attitude.”

                                <br />
                            </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The school organised a three-day Bhagavad Gita learning programme for Classes 3 and 5 with the objective of helping students understand moral values and life lessons through simple explanations, stories, and Slokas connected to real-life situations.  
                                <br></br>
                                Day 1 focused on Chapters 1 and 2, where students were introduced to the background of the Gita and Arjuna’s dilemma. Through engaging stories and examples, children learnt about emotions, right decision-making and inner strength. Students enthusiastically learnt new Slokas and actively participated in discussions, showing keen interest and curiosity.
                                <br></br>
                                Day 2 centred on Chapter 3 – Karma Yoga, emphasising the importance of action. Students understood the message of doing one’s duty without worrying about results and learnt why action is superior to inaction. Concepts such as self-control, discipline and lifelong learning were explained using relatable examples. Slokas and a meaningful Subhashitham reinforced the values discussed.
                                <br></br>
                                Day 3, the final day, highlighted Jnana Yoga – the Yoga of Knowledge. Through a short moral story and Slokas, students learnt about the decline of righteousness, the rise of evil and the role of Lord Krishna in restoring Dharma. The session concluded with three key takeaways: the promise of protection, the power of purpose and the force of true knowledge, leaving a lasting impact on young minds.
                                <br></br>
                                The three-days programme was enriching and inspiring. Students participated with great enthusiasm and gained valuable insights that will guide them in their daily lives, helping them grow into responsible, thoughtful, and value-driven individuals.
                                   
                                </Typography>
                            </Box>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default GitaDharaClass3;